import type {ListCardFooterControls} from "~/components/ottopilotDataViewer/listCardComponent";
import type {
    OttopilotListCardFooterBindings,
    OttopilotListCardFunnelOptions,
} from "~/components/ottopilotDataViewer/ottopilotListCardPresentation";
import type {ScheduleCallNavigateFn} from "~/components/scheduleCall/navigateToScheduleCallRoute";
import {EMOTORAD_JOURNEY_LIST_FUNNEL_STAGE_COLUMN_IDS} from "~/domainModels/workspaceSpecific/emotorad";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function createEmotoradJourneyListFunnelOptions<T>(
    getAdditionalColumnValues: (row: T) => Record<Uuid, unknown>,
): OttopilotListCardFunnelOptions<T> {
    return {
        stageColumnIds: EMOTORAD_JOURNEY_LIST_FUNNEL_STAGE_COLUMN_IDS,
        getAdditionalColumnValues,
    };
}

/** @deprecated Use `ScheduleCallNavigateFn`. */
export type EmotoradScheduleNavigateFn = ScheduleCallNavigateFn;

export {navigateToScheduleCallRoute as navigateToEmotoradScheduleCallRoute} from "~/components/scheduleCall/navigateToScheduleCallRoute";

/** Opens the device dialer when `rawPhone` has non-whitespace digits/content. */
export function ottopilotDialPhoneNumber(rawPhone: string | null | undefined): void {
    const trimmed = String(rawPhone ?? "").trim();
    if (trimmed === "" || typeof window === "undefined") {
        return;
    }
    window.location.href = `tel:${trimmed.replace(/\s+/g, "")}`;
}

export function resolveListCardFooterWhenEnabled(
    showFooter: boolean,
    bindings: OttopilotListCardFooterBindings,
    footerCorrelationId: Uuid,
): ListCardFooterControls | null {
    return showFooter === true ? bindings.getFooterControls(footerCorrelationId) : null;
}
